import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from 'containers/Full'
import NotFound from 'containers/NotFound'

// Views - These have been set up for lazy loading of the view components
const Home = () => import('views/Home.vue')
const Gallery = () => import('views/Gallery.vue')
// const Prices = () => import('views/Prices.vue')
const Contact = () => import('views/Contact.vue')
// const Blog = () => import('views/Blog.vue')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'app',
      component: Full,
      children: [
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'gallery',
          name: 'gallery',
          component: Gallery
        },
        // {
        //   path: 'prices',
        //   name: 'prices',
        //   component: Prices
        // },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        }
        // ,
        // {
        //   path: 'blog',
        //   name: 'blog',
        //   component: Blog
        // }
      ]
    },
    {
      path: '*',
      name: 'notFound',
      redirect: '/notFound',
      component: Full,
      children: [
        {
          path: 'notFound',
          name: 'notFound404',
          component: NotFound
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js